<template>
<BootstrapDialog title="直播观看详情" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row">
		        <div class="col-sm-12">
					<table class="table table-bordered" style="font-size: 14px;">
						<thead>
							<tr>
								<th rowspan="2" style="vertical-align: middle;text-align: center;">序号</th>
								<th rowspan="2" style="vertical-align: middle;text-align: center;">直播标题</th>
								<th rowspan="2" style="vertical-align: middle;text-align: center;">开始时间</th>
								<th rowspan="2" style="vertical-align: middle;text-align: center;">结束时间</th>
								<th rowspan="2" style="vertical-align: middle;text-align: center;">直播时长(分钟)</th>
								<th colspan="2" style="vertical-align: middle;text-align: center;">观看时长(分钟)</th>
							</tr>	
							<tr>
								<th>直播(分钟)</th>
								<th>录播(分钟)</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item,index) in list" :key="item.zbid">
								<td style="vertical-align: middle;text-align: center;">{{index+1}}</td>
								<td style="vertical-align: middle;text-align: center;">{{item.zbbt || ''}}</td>
								<td style="vertical-align: middle;text-align: center;">{{item.kssj|| ''}}</td>
								<td style="vertical-align: middle;text-align: center;">{{item.jssj|| ''}}</td>
								<td style="vertical-align: middle;text-align: center;">{{item.zbsc|| ''}}</td>
								<td style="vertical-align: middle;text-align: center;">{{item.zbgksc|| ''}}</td>
								<td style="vertical-align: middle;text-align: center;">{{item.lbgksc|| ''}}</td>
							</tr>
						</tbody>
					</table>
		        </div>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
			<button class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     * 直播管理-学生观看情况-详情页
     .
     */

    import tableMixin from '@/mixins/table.js';
    export default {
        mixins: [tableMixin],
        name:'ZhiboLearningQkDetail',
        data:function(){
            return {
				list:[],
				query:{
					xmId:'',
					kcId:'',
					ksId:''
				}
            }
        },
        methods:{
			reset:function(){
				this.list = [];
				this.query = {
					xmId:'',
					kcId:'',
					ksId:''
				}
			},
			async open(params){
				this.query.xmId = params.xmId || '';
				this.query.kcId = params.kcId || '';
				this.query.ksId = params.ksId || '';
				let res =await this.$http.post('/htgl/biz/zypx/zb/xsgkqk/getDetail',this.query);
				if(res.data){
					this.list = res.data || [];
				}
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			}
        }
    }
</script>